export const linkBoxConfigSchema = {
  type: 'object',
  properties: {
    icons: {
      type: 'object'
    }
  }
}
